import React, { useMemo } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { useStaffContext } from 'store';
import Home from 'page/index';
import Login from 'page/login';
import PrivateRoute from 'page/privateRoute';

const lazyRetry = (componentImport) => (
    new Promise((resolve) => {
        const hasRefreshed = JSON.parse(sessionStorage.getItem('react-lazy-refreshed') || 'false');
        componentImport().then((component) => {
            sessionStorage.setItem('react-lazy-refreshed', 'false');
            resolve(component);
        }).catch(() => {
            if (!hasRefreshed) {
                sessionStorage.setItem('react-lazy-refreshed', 'true');
                window.location.reload();
            }
            resolve({ default: () => <></> });
        });
    })
);

const Page = (props) => {
    const { name } = props;
    return (
        <React.Suspense fallback={null}>
            {(() => {
                const Component = React.lazy(() => lazyRetry(() => import(`page/${name}`)));
                return <Component />;
            })()}
        </React.Suspense>
    );
};

const Router = () => {
    const { pages } = useStaffContext();
    const router = useMemo(() => (
        createBrowserRouter(
            [
                {
                    path: '/login',
                    element: <Login />
                },
                {
                    path: '*',
                    element: <PrivateRoute element={<Home />} />,
                    children: pages.map((module) => ({
                        ...module,
                        children: module.children?.map((page) => ({
                            ...page,
                            element: <PrivateRoute element={<Page name={`${module.key}/${page.path}`} />} />
                        }))
                    }))
                }
            ],
            { basename: '/' }
        )
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), []);
    return <RouterProvider router={router} />;
};

export default Router;
